module.exports = __webpack_public_path__ + "img/down.c2b4c94b.svg";